import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CheckBox from '@components/CheckBox';
import { changeUserExperimentalFeatures } from '@containers/Admin/containers/UserPage/actions';
import { ROLES } from '@containers/Admin/shared/roles';
import { ItemWithLabel } from './ItemWithLabel';
import { ItemWithLabelWrapper } from './ItemWithLabel/styles';

export const ExperimentalFeatures = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userData } = useSelector((state: RootStateOrAny) => state.get('userPage').toJS());
  const { roles } = useSelector((state: RootStateOrAny) => state.getIn(['app', 'authentication', 'user']).toJS());
  const canEdit = roles.includes(ROLES.TECH_ADMIN);
  const experimentalFeatures = userData.experimentalFeatures ?? false;

  const onChangeExperimentalFeatures = (checked: boolean): void => {
    dispatch(changeUserExperimentalFeatures(checked, userData.id));
  };

  if (!canEdit) {
    return (
      <ItemWithLabel label={<span>{t('Informative.Labels.experimentalFeatures')}</span>}>
        {experimentalFeatures ? t('Actions.Simple.yes') : t('Actions.Simple.no')}
      </ItemWithLabel>
    );
  }

  return (
    <ItemWithLabelWrapper>
      <CheckBox
        value={experimentalFeatures}
        onChange={onChangeExperimentalFeatures}
        label={t('Informative.Labels.experimentalFeatures')}
      />
    </ItemWithLabelWrapper>
  );
};